import React, {useEffect} from 'react';
import {navigate} from '@reach/router';
import MasterClassIndex from './health';

export default function (props) {
  useEffect(() => {
    navigate('/masterclass/health/' + location.search);
  }, []);
  return <MasterClassIndex />;
}
